import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";
import BrandMark from "@/pages/home/components/BrandMark";

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200/80 bg-background-50/90 backdrop-blur-md"
          : "border-transparent bg-background-50/60 backdrop-blur-sm"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="shrink-0 cursor-pointer">
          <BrandMark />
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="cursor-pointer rounded-full px-3.5 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3.5 py-2 text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="text"
              placeholder="搜索视频"
              className="w-28 bg-transparent font-label text-sm text-foreground-800 outline-none placeholder:text-foreground-400 lg:w-36"
            />
          </div>
          <button
            type="button"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-user-smile-line text-base"></i>
            免费畅看
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-lg px-3 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3.5 py-2.5 text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="text"
              placeholder="搜索视频"
              className="w-full bg-transparent font-label text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            className="mt-3 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50"
          >
            <i className="ri-user-smile-line text-base"></i>
            免费畅看
          </button>
        </div>
      )}
    </header>
  );
}